import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Divider,
  IconButton,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import EditIcon from "@mui/icons-material/Edit";
import { useSelector } from "react-redux";
import { BASE_URL_TEST } from "../../../utils/baseUrl";
import { urls } from "../../../urls/urls";
import { useFetch, useUpdate } from "../../../hooks";
import {
  validateAccountNumber,
  validateIfscCode,
  validateName,
} from "../../../utils/textFieldValidations";

export default function PaymentBankingSettings() {
  
  const [openAddAccount, setOpenAddAccount] = useState(false);
  const [openChangeDate, setOpenChangeDate] = useState(false);
  const [newAccount, setNewAccount] = useState({
    bankName: "",
    accountNumber: "",
    confirmAccountNumber: "",
    ifscCode: "",
    bankHolderName: "",
    branchName: "",
  });
  const [newDate, setNewDate] = useState("");
  const loginToken = useSelector((state) => state.user.logintoken);
  const userDetails = useSelector((state) => state.user.userdetails);
  const [payoutFrequency, setPayoutFrequency] = useState("Every " + userDetails.payout + "th");
  const [errors, setErrors] = useState({});
  const [isEditMode, setEditMode] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedImage, setSelectedImage] = useState(null);
  const [open, setOpen] = useState(false);
  const [selectedBannerId, setSelectedBannerId] = useState(null);
  const [isModalOpen, setModalOpen] = useState(false);
  const [data, setData] = useState("");
  const [isDeleteModalOpen, setDeleteModalOpen] = useState(false);
  const [snackbarState, setSnackbarState] = useState({
    message: "",
    status: "",
  });
  const initializeAccountDetails = () => {
    setNewAccount({
      bankName: "",
      accountNumber: "",
      confirmAccountNumber: "",
      ifscCode: "",
      bankHolderName: "",
      branchName: "",
    });
  };
  //get All Banners data
  useEffect(() => {
    fetchData();
  }, []);

  //get All Banners data
  const {
    data: bankDetailsData,
    isLoading: isbankDetailsLoading,
    error,
    fetchData,
  } = useFetch(
    BASE_URL_TEST + urls("getAllVendorBankDetails", userDetails.id),
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: loginToken ? `Bearer ${loginToken}` : "",
      },
    }
  );
  const {
    data: createBankDetailsData,
    isLoading: createBankDetailsLoading,
    error: createBankDetailsError,
    fetchData: fetchCreateData,
  } = useFetch(BASE_URL_TEST + urls("createVendorBankDetails"), {
    method: "POST",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: updateBankDetailsData,
    isLoading: updateBankDetailsLoading,
    error: updateBankDetailsError,
    updateData: fetchUpdateData,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });

  const {
    data: changePrimaryStatus,
    isLoading: changePrimaryStatusLoading,
    error: changePrimaryStatusError,
    updateData: fetchPrimaryStatus,
  } = useUpdate(BASE_URL_TEST, {
    method: "PUT",
    headers: {
      Authorization: loginToken ? `Bearer ${loginToken}` : "",
    },
  });
  useEffect(() => {
    if (error) {
    } else if (bankDetailsData && bankDetailsData["status"] === true) {
      setData(bankDetailsData["data"]);
    }
  }, [bankDetailsData, error]);

  //Create Bank details
  useEffect(() => {
    if (createBankDetailsError) {
    } else if (
      createBankDetailsData &&
      createBankDetailsData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: createBankDetailsData["message"],
        status: createBankDetailsData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (
      createBankDetailsData &&
      createBankDetailsData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: createBankDetailsData["message"],
        status: createBankDetailsData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [createBankDetailsData, createBankDetailsError]);
  //update bank details
  useEffect(() => {
    if (updateBankDetailsError) {
    } else if (
      updateBankDetailsData &&
      updateBankDetailsData["status"] === true
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updateBankDetailsData["message"],
        status: updateBankDetailsData["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (
      updateBankDetailsData &&
      updateBankDetailsData["status"] === false
    ) {
      setSnackbarState({
        ...snackbarState,
        message: updateBankDetailsData["message"],
        status: updateBankDetailsData["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [updateBankDetailsData, updateBankDetailsError]);

  useEffect(() => {
    if (changePrimaryStatusError) {
    } else if (changePrimaryStatus && changePrimaryStatus["status"] === true) {
      setSnackbarState({
        ...snackbarState,
        message: changePrimaryStatus["message"],
        status: changePrimaryStatus["status"],
      });
      setModalOpen(true);
      fetchData();
    } else if (changePrimaryStatus && changePrimaryStatus["status"] === false) {
      setSnackbarState({
        ...snackbarState,
        message: changePrimaryStatus["message"],
        status: changePrimaryStatus["status"],
      });
      setModalOpen(true);
      fetchData();
    }
  }, [changePrimaryStatus, changePrimaryStatusError]);

  const clearErrors = () => {
    setErrors({});
  };

  const filteredData = Array.isArray(data) && data.length > 0 ? data : [];

  //Handle "Add Account"
  const handleAddAccount = () => {
    setEditMode(false);
    initializeAccountDetails();
    setErrors({});
    setOpenAddAccount(true);
  };
  const handleAddAccountClose = () => setOpenAddAccount(false);

  const handleAddAccountSave = () => {
   
    let validationErrors = {};
    if (!newAccount["bankName"] || !newAccount["bankName"].trim()) {
      validationErrors.bankName = "Bank Name is required.";
      setErrors(validationErrors);
      return;
    }
    if (!validateAccountNumber(newAccount["accountNumber"])) {
      validationErrors.accountNumber =
        "Please enter a valid bank account number. It should contain only digits and be between 9 to 18 characters long.";
      setErrors(validationErrors);
      return;
    }
    if(!isEditMode){
    if (
      !newAccount["confirmAccountNumber"] ||
      !newAccount["confirmAccountNumber"].trim()
    ) {
      validationErrors.confirmAccountNumber =
        "Confirm bank account number required.";
      setErrors(validationErrors);
      return;
    }
    if (newAccount["accountNumber"] !== newAccount["confirmAccountNumber"]) {
      validationErrors.confirmAccountNumber = "Account numbers do not match.";
      setErrors(validationErrors);
      return false;
    }
  }
    if (!validateIfscCode(newAccount["ifscCode"])) {
      validationErrors.ifscCode =
        "Please enter a valid IFSC code. It should be 11 characters long, starting with 4 letters, followed by '0', and ending with 6 digits.";
      setErrors(validationErrors);
      return;
    }

    if (!validateName(newAccount["bankHolderName"])) {
      validationErrors.bankHolderName =
        "Bank Holder Name is required and should only contain letters and spaces.";
      setErrors(validationErrors);
      return;
    }
    if (!newAccount["branchName"] || !newAccount["branchName"].trim()) {
      validationErrors.branchName = "Branch Name is required.";
      setErrors(validationErrors);
      return;
    }
    clearErrors();
    
    const saveBody = {
      bank_holder_name: newAccount["bankHolderName"],
      account_number: newAccount["confirmAccountNumber"],
      ifsc_code: newAccount["ifscCode"],
      bank_name: newAccount["bankName"],
      branch_name: newAccount["branchName"],
    };
  
    if (isEditMode) {
      const updateUrl = urls("updateVendorBankDetails", newAccount["bankId"]);
      fetchUpdateData(updateUrl, saveBody);
    } else if (!isEditMode) {
      saveBody.vendor_id = userDetails.id
      fetchCreateData(saveBody);
    }
  };

  // Handle Change Primary Account
  const handlePrimaryChange = (account, selectedAccountId) => {
    if (account.is_primary === 1) return;

    const updatedAccount = {
      ...account,
      is_primary: 1,
    };

    // Loop the other accounts and set their primary status to false
    const updatedAccounts = filteredData.map((acc) =>
      acc.id === selectedAccountId
        ? { ...acc, is_primary: 1 }
        : { ...acc, is_primary: 0 }
    );
    setData(updatedAccounts); // Update the UI state
    const saveBody = {
      vendor_id: userDetails.id,
      is_primary: updatedAccount.is_primary,
      id: updatedAccount.id,
    };
    const chnagePrimaryStatusUrl = urls("changePrimaryStatus");
    fetchPrimaryStatus(chnagePrimaryStatusUrl, saveBody);
  };

  // Handle "Change Date"
  const handleChangeDateClick = () => {
    clearErrors();
    setNewDate("");
    setOpenChangeDate(true);
  }
  const handleChangeDateClose = () => {
    setOpenChangeDate(false);
  }

  const handleDateSave = () => {
    let validation = {};

    if (!newDate) {
      validation.newDate = "Date is required.";
      setErrors(validation);
      return;
    }
    const saveBody = {
        vendor_id: userDetails.id,
        payout: newDate
    };
   
      const payoutFrequencyUrl = urls("updatePayoutFrequency");
      fetchUpdateData(payoutFrequencyUrl, saveBody);
    
    setPayoutFrequency(`Every ${newDate}` + 'th');
    setOpenChangeDate(false);
  };
  const handleEdit = async (account) => {
    setEditMode(true);
    setOpenAddAccount(true);
    setNewAccount({
      ...account,
      bankName: account["bank_name"],
      accountNumber: account["account_number"],
      ifscCode: account["ifsc_code"],
      bankHolderName: account["bank_holder_name"],
      branchName: account["branch_name"],
      bankId: account["id"]
    });
  };
  const handleClose = () => {
    setModalOpen(false);
    if (createBankDetailsData && createBankDetailsData["status"] === true) {
      initializeAccountDetails();
      setOpenAddAccount(false);
      clearErrors();
    }
    if (updateBankDetailsData && updateBankDetailsData["status"] === true) {
      initializeAccountDetails();
      setOpenAddAccount(false);
      clearErrors();
    }
  };

  return (
    <Box
      sx={{
        bgcolor: "white",
        p: 4,
        borderRadius: "20px",
        boxShadow: 1,
        maxWidth: 1200,
        mx: "auto",
      }}
    >
      {/* Bank Account Details Section */}
      <Box>
        <Typography
          variant="h6"
          sx={{ mb: 2, display: "flex", alignItems: "center" }}
        >
          Bank Account Details{" "}
          <InfoOutlinedIcon fontSize="small" sx={{ ml: 1 }} />
        </Typography>
        <RadioGroup>
          {filteredData.map((account) => (
            <Box
              key={account.id}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                p: 2,
                border: "1px solid #e0e0e0",
                borderRadius: 1,
                mb: 2,
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <InfoOutlinedIcon
                  sx={{ mr: 2, fontSize: 32, color: "#3f51b5" }}
                />
                <Box>
                  <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
                    {account.bank_name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    {account.account_number}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    {account.ifsc_code}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "gray" }}>
                    {account.branch_name}
                  </Typography>
                </Box>
              </Box>
              <FormControlLabel
                control={
                  <Radio
                    checked={account.is_primary === 1}
                    onChange={() => handlePrimaryChange(account, account.id)}
                  />
                }
                label={account.is_primary === 1 ? "Primary" : ""}
              />
                <MenuItem onClick={() => handleEdit(account)}>
                              <EditIcon />
                            </MenuItem>
            </Box>
          ))}
        </RadioGroup>
        <Button
          startIcon={<AddCircleOutlineIcon />}
          onClick={handleAddAccount}xx
          sx={{ color: "#3f51b5", textTransform: "none" }}
        >
          Add Account
        </Button>
      </Box>

      <Divider sx={{ my: 4 }} />

      {/* Payout Frequency Section */}
      <Box>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Payout Frequency
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            p: 2,
            border: "1px solid #e0e0e0",
            borderRadius: 1,
            mb: 3,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body1" sx={{ mr: 2 }}>
              {payoutFrequency}
            </Typography>
            <CalendarTodayIcon sx={{ color: "#3f51b5" }} />
          </Box>
          <Button
            onClick={handleChangeDateClick}
            sx={{ textTransform: "none", color: "#3f51b5", fontSize: "0.9rem" }}
          >
            Change date
          </Button>
        </Box>
      </Box>

      {/* Action Buttons */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
        <Button
          variant="outlined"
          sx={{ mr: 2, color: "#3f51b5", borderColor: "#3f51b5" }}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          sx={{
            bgcolor: "#3f51b5",
            "&:hover": { bgcolor: "#303f9f" },
          }}
        >
          Save
        </Button>
      </Box>

      {/* Add Account Dialog */}
      <Dialog open={openAddAccount} onClose={handleAddAccountClose}>
        <DialogTitle>Add Account</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Bank Name"
            value={newAccount.bankName}
            onChange={(e) =>
              setNewAccount({ ...newAccount, bankName: e.target.value })
            }
            error={!!errors.bankName}
            helperText={
              errors.bankName && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.bankName}
                </Typography>
              )
            }
          />
          <TextField
            fullWidth
            margin="dense"
            label="Account Number"
            value={newAccount.accountNumber}
            onChange={(e) =>
              setNewAccount({ ...newAccount, accountNumber: e.target.value })
            }
            error={!!errors.accountNumber}
            helperText={
              errors.accountNumber && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.accountNumber}
                </Typography>
              )
            }
          />
          {!isEditMode ? (
          <TextField
            fullWidth
            margin="dense"
            label="Confirm Account Number"
            value={newAccount.confirmAccountNumber}
            onChange={(e) =>
              setNewAccount({
                ...newAccount,
                confirmAccountNumber: e.target.value,
              })
            }
            type="password" // This makes the input appear as dots or asterisks
            error={!!errors.confirmAccountNumber}
            helperText={
              errors.confirmAccountNumber && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.confirmAccountNumber}
                </Typography>
              )
            }
          />):(
          ""
          )}
          <TextField
            fullWidth
            margin="dense"
            label="IFSC Code"
            value={newAccount.ifscCode}
            placeholder="SBIN0001234"
            onChange={(e) =>
              setNewAccount({ ...newAccount, ifscCode: e.target.value })
            }
            helperText={
              errors.ifscCode && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.ifscCode}
                </Typography>
              )
            }
          />
          <TextField
            fullWidth
            margin="dense"
            label="Holder Name"
            value={newAccount.bankHolderName}
            onChange={(e) =>
              setNewAccount({ ...newAccount, bankHolderName: e.target.value })
            }
            helperText={
              errors.bankHolderName && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.bankHolderName}
                </Typography>
              )
            }
          />
          <TextField
            fullWidth
            margin="dense"
            label="Branch Name"
            value={newAccount.branchName}
            onChange={(e) =>
              setNewAccount({ ...newAccount, branchName: e.target.value })
            }
            helperText={
              errors.branchName && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.branchName}
                </Typography>
              )
            }
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleAddAccountClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleAddAccountSave}
            color="primary"
            variant="contained"
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>

      {/* Change Date Dialog */}
      <Dialog open={openChangeDate} onClose={handleChangeDateClose}>
        <DialogTitle>Change Payout Date</DialogTitle>
        <DialogContent>
          <TextField
            select
            fullWidth
            margin="dense"
            label="Select Date"
            value={newDate}
            onChange={(e) => setNewDate(e.target.value)}
            helperText={
              errors.newDate && (
                <Typography
                  sx={{
                    textAlign: "left",
                    marginTop: 1,
                    color: "red",
                    fontSize: 12,
                  }}
                >
                  {errors.newDate}
                </Typography>
              )
            }
          >
            
            {Array.from({ length: 30 }, (_, i) => i + 1).map((date) => (
              <MenuItem key={date} value={date}>
                {date}
              </MenuItem>
            ))}
            
          </TextField>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleChangeDateClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDateSave} color="primary" variant="contained">
            Save
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={isModalOpen} onClose={() => setModalOpen(false)}>
        <DialogTitle>
          {snackbarState.status === true ? "Success" : "Error"}
        </DialogTitle>
        <DialogContent>
          <Typography
            variant="body1"
            sx={{
              color: snackbarState.status === true ? "green" : "red",
            }}
          >
            {snackbarState.message}
          </Typography>
        </DialogContent>
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            variant="contained"
            color="primary"
            onClick={handleClose}
            sx={{
              textTransform: "none",
              borderRadius: 2,
              alignSelf: "center",
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
}
